<template>
  <el-dialog
    title="所有专业"
    :visible.sync="show"
    width="80%" @open="open" @close="closeForm()" top="2vh">
      <!--主体-->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span
              >{{ form.collegeName }}
              <span v-if="form.detail">{{ form.detail.collegeProperty }}</span>
            </span>
            <span style="float: right; padding: 3px 0"
              >专业数量：{{list.length}}</span
            >
          </div>
          <div style="width: 100%; display: flex; flex-wrap: wrap">
            <div style="width: 20%; display: flex; align-items: center">
              录取省份：{{ form.province }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              预测年份：{{ form.current_year }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              录取批次：{{ form.batch }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              组别：{{ form.group_d }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              预测最低分：<span style="color: #177dff !important">{{
                form.score || "--"
              }}</span>
            </div>
          </div>
        </el-card>
       <div style="width: 100%;height: 500px;overflow-y: scroll;margin-top: 20px;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}">
          <el-table-column label="专业名称" align="center">
            <template slot-scope="scope">
               {{scope.row.specialty_title}}
            </template>
          </el-table-column>
          <el-table-column label="专业方向" align="center">
            <template slot-scope="scope">
               {{scope.row.major_field}}
            </template>
          </el-table-column>
          <el-table-column label="专业简注" align="center" width="320">
            <template slot-scope="scope">
               {{scope.row.major_remark}}
            </template>
          </el-table-column>
          <el-table-column label="批次" align="center">
            <template slot-scope="scope">
               {{scope.row.batch}}
            </template>
          </el-table-column>
          <el-table-column label="组别" align="center">
            <template slot-scope="scope">
               {{scope.row.group_d}}
            </template>
          </el-table-column>
          <el-table-column label="次选科目" align="center">
            <template slot-scope="scope">
               {{scope.row.the_second}}
            </template>
          </el-table-column>
          <el-table-column label="招生人数/学制" align="center">
            <template slot-scope="scope">
               {{scope.row.planned_number}}/{{scope.row.schooling_length}}
            </template>
          </el-table-column>
          <el-table-column label="学费" align="center">
            <template slot-scope="scope">
               {{scope.row.tuition_fee==-1?"待定":scope.row.tuition_fee==0?"免费":scope.row.tuition_fee}}
            </template>
          </el-table-column>
      </el-table>
       </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" :size="size" @click="closeForm"
            >确 定</el-button
          >
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { RecruitData_detail } from "@/api/gw/major.js";
import { Mojor_recodeList } from "@/api/gw/zonghe.js"
export default {
  name: "RecruitDatadetail",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "mini",
    },
    info: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
      list:[],
    };
  },
  methods: {
    open() {
      RecruitData_detail(this.info).then((res) => {
        this.form = res.data;
        this.Mojor_recodeList();
      });
    },
    Mojor_recodeList(){
      Mojor_recodeList({
        recruitdata_id:this.info.recruitdata_id
      }).then(res=>{
        console.log("所有专业",res.data);
        this.list = res.data
      })
    },
    closeForm() {
      this.$parent.dialog.zhuanyeDIALOG = false
    },
  },
};
</script>
<style  lang="scss">
.descLabel {
  width: 90px;
}
.table {
  color: #555 !important;
  width: 100%;
}
.table-bordered {
  border: 1px solid #dee2e6;
}
.table td,
.table th {
  font-size: 13px;
  border-top-width: 0px;
  border-bottom: 1px solid;
  border-color: #ebedf2 !important;
  padding: 0.75rem !important;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/views/RecruitData/components/zhuanye.vue